import { create } from 'zustand';

interface ScopeCollapseState {
  /**
   * Map of action names to their collapse state.
   * Key: action name (e.g. "ForEach_1"), matching data.actionName on scope nodes
   * Value: true if collapsed, false if expanded
   */
  collapsedNodes: Record<string, boolean>;

  /**
   * Toggle collapse state for an action
   */
  toggleCollapse: (actionName: string) => void;

  /**
   * Set collapse state for an action
   */
  setCollapsed: (actionName: string, collapsed: boolean) => void;

  /**
   * Check if an action is collapsed
   */
  isCollapsed: (actionName: string) => boolean;

  /**
   * Clear all collapse state (e.g., when switching workflows)
   */
  clearAll: () => void;
}

export const useScopeCollapseStore = create<ScopeCollapseState>((set, get) => ({
  collapsedNodes: {},

  toggleCollapse: (nodeId) =>
    set((state) => ({
      collapsedNodes: {
        ...state.collapsedNodes,
        [nodeId]: !state.collapsedNodes[nodeId],
      },
    })),

  setCollapsed: (nodeId, collapsed) =>
    set((state) => ({
      collapsedNodes: {
        ...state.collapsedNodes,
        [nodeId]: collapsed,
      },
    })),

  isCollapsed: (nodeId) => get().collapsedNodes[nodeId] ?? false,

  clearAll: () => set({ collapsedNodes: {} }),
}));
